export var Kind;
(function (Kind) {
    Kind["OnSceneUserInteraction"] = "onSceneUserInteraction";
    Kind["OnSelectAttachmentOption"] = "onSelectAttachmentOption";
    Kind["OnError"] = "OnError";
    Kind["OnLoadSuccess"] = "onLoadSuccess";
    Kind["OnFurnitureClick"] = "onFurnitureClick";
    Kind["OnFurnitureModuleClick"] = "onFurnitureModuleClick";
    Kind["OnFurnitureRemoval"] = "onFurnitureRemoval";
    Kind["OnSceneClick"] = "onSceneClick";
})(Kind || (Kind = {}));
